import { Typography } from '@mui/material';
import { resolveDetailPageTitle } from './detailPageTitle';

type DetailPageHeadingProps = {
  template: string | null | undefined;
  values: Record<string, unknown> | undefined;
};

export const DetailPageHeading = ({ template, values }: DetailPageHeadingProps) => (
  <Typography variant="h4" sx={{ mb: 1.5, pl: 2, flexShrink: 0 }}>
    {resolveDetailPageTitle(template, values)}
  </Typography>
);
